var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 1.33594H3.16667C2.72464 1.33594 2.30072 1.51153 1.98816 1.82409C1.67559 2.13665 1.5 2.56058 1.5 3.0026V11.3359C1.5 11.778 1.67559 12.2019 1.98816 12.5144C2.30072 12.827 2.72464 13.0026 3.16667 13.0026H5.82333C6.65667 13.0026 7.33333 13.6784 7.33333 14.5126C7.33333 15.1859 8.14667 15.5226 8.6225 15.0468L10.1783 13.4909C10.4908 13.1784 10.9147 13.0027 11.3567 13.0026H14.8333C15.2754 13.0026 15.6993 12.827 16.0118 12.5144C16.3244 12.2019 16.5 11.778 16.5 11.3359V3.0026C16.5 2.56058 16.3244 2.13665 16.0118 1.82409C15.6993 1.51153 15.2754 1.33594 14.8333 1.33594Z",
    stroke: "#333333",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostComment);
export default __webpack_public_path__ + "static/media/PostComment.f8001ea03d67f971bcbb43c70f28537b.svg";
export { ForwardRef as ReactComponent };